export enum SocialNetworkThreadOwnerType {
  PARTICIPANT = 'PARTICIPANT',
  HUB = 'HUB',
  GROUP = 'GROUP',
}
